module.exports = __webpack_public_path__ + "img/arrow-right.cb845325.svg";